import _regeneratorRuntime from "@babel/runtime/regenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import EventEmitter from 'events';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
var _global = globalThis;
var initDynamicLoadEventEmitter = function initDynamicLoadEventEmitter() {
  if (_global.dynamicLoadEventEmitter) {
    return _global.dynamicLoadEventEmitter;
  }
  var res = {
    events: new EventEmitter(),
    countMap: {},
    loadComponentMap: {},
    sortMap: {}
  };
  _global.dynamicLoadEventEmitter = res;
  return res;
};
/**
 * 当某个 ui 组件加载之后，需要按需加载对应组件的样式。
 */

export var dynamicLoadEventEmitter = initDynamicLoadEventEmitter();
/**
 * data Structure example:
 * c7nUiComponentId: choerodon-ui::{xx} | hzero-ui::{xx}
 * name: choerodon-ui | hzero-ui
 * countMap: {
 *  choerodon-ui: Map()
    [[Entries]]
      0: {"choerodon-ui::{xx}" => Number}
        key: "choerodon-ui::{xx}"
        value: 1
 * }
 */

export var notifyComponentLoaded = function notifyComponentLoaded(c7nUiComponentId) {
  if (!c7nUiComponentId) {
    return;
  }
  var name = c7nUiComponentId.split('::')[0];
  var countMap = dynamicLoadEventEmitter.countMap[name];
  if (!countMap) {
    countMap = new Map();
    dynamicLoadEventEmitter.countMap[name] = countMap;
  }
  countMap.set(c7nUiComponentId, (countMap.get(c7nUiComponentId) || 0) + 1);
  dynamicLoadEventEmitter.events.emit('load', c7nUiComponentId);
};
export var notifyComponentUnLoaded = function notifyComponentUnLoaded(c7nUiComponentId) {
  if (!c7nUiComponentId) {
    return;
  }
  var name = c7nUiComponentId.split('::')[0];
  var countMap = dynamicLoadEventEmitter.countMap[name];
  if (!countMap) {
    dynamicLoadEventEmitter.countMap[name] = new Map();
  }
  var count = countMap.get(c7nUiComponentId);
  if (count === undefined) {
    return;
  }
  count = count - 1;
  if (count <= 0) {
    countMap["delete"](c7nUiComponentId);
    dynamicLoadEventEmitter.events.emit('unLoad', "".concat(c7nUiComponentId));
  } else {
    countMap.set(c7nUiComponentId, count);
  }
};
/**
 * @param listenKey: {name::componentName} - eg 'choerodon-ui::alert'
 * @param loadCssData: () => import({StyleComponentCreatorRet})
 * @param uidKey: `${Math.random().toString().slice(2, 10)}${Date.now()}`
 */

export var setLoadEffectCssComponent = function setLoadEffectCssComponent(listenKey, loadCssData, uidKey, index) {
  var _dynamicLoadEventEmit;
  dynamicLoadEventEmitter.sortMap[listenKey] = index;
  var list = (_dynamicLoadEventEmit = dynamicLoadEventEmitter.loadComponentMap[uidKey]) === null || _dynamicLoadEventEmit === void 0 ? void 0 : _dynamicLoadEventEmit.get(listenKey);
  if (!Array.isArray(list)) {
    list = [];
    var map = dynamicLoadEventEmitter.loadComponentMap[uidKey];
    if (!map) {
      map = new Map();
      dynamicLoadEventEmitter.loadComponentMap[uidKey] = map;
    }
    map.set(listenKey, list);
  }
  list.push(loadCssData);
};
export var useLoadStyles = function useLoadStyles(name, uidKey) {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    loadStyles = _useState2[0],
    setLoadStyles = _useState2[1];
  useEffect(function () {
    var promiseCache = new Map();
    var refreshLoadStyles = debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var countMap, allPromise, isNeedChange, res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              countMap = dynamicLoadEventEmitter.countMap[name];
              if (countMap) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              allPromise = [];
              isNeedChange = false;
              _toConsumableArray(countMap.keys()).forEach(function (key) {
                var _dynamicLoadEventEmit2, _dynamicLoadEventEmit3;
                var list = (_dynamicLoadEventEmit2 = dynamicLoadEventEmitter.loadComponentMap) === null || _dynamicLoadEventEmit2 === void 0 ? void 0 : (_dynamicLoadEventEmit3 = _dynamicLoadEventEmit2[uidKey]) === null || _dynamicLoadEventEmit3 === void 0 ? void 0 : _dynamicLoadEventEmit3.get(key);
                if (!list) {
                  return;
                }
                list.forEach(function (item) {
                  var cacheValue = promiseCache.get(item);
                  if (cacheValue) {
                    isNeedChange = true;
                    allPromise.push(Promise.resolve(cacheValue));
                  } else {
                    isNeedChange = true;
                    allPromise.push(item().then(function (_v) {
                      var v = _v["default"] || _v;
                      promiseCache.set(item, v);
                      dynamicLoadEventEmitter.sortMap["".concat(name, "-").concat(v.name)] = dynamicLoadEventEmitter.sortMap[key];
                      return v;
                    }));
                  }
                });
              });
              if (!isNeedChange) {
                _context.next = 11;
                break;
              }
              _context.next = 9;
              return Promise.all(allPromise);
            case 9:
              res = _context.sent;
              setLoadStyles(res);
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    refreshLoadStyles();
    var lis = function lis(c7nUiComponentId) {
      if (!c7nUiComponentId.startsWith("".concat(name, "::"))) {
        return;
      }
      refreshLoadStyles();
    };
    dynamicLoadEventEmitter.events.on('load', lis); // dynamicLoadEventEmitter.events.on('unLoad', lis);

    return function () {
      dynamicLoadEventEmitter.events.off('load', lis); // dynamicLoadEventEmitter.events.off('unLoad', lis);
    };
  }, [name, uidKey]);
  return loadStyles;
};